// src/domains/user/user.const.ts

import { IUserSettings } from './user.types';

export const USER_SETTINGS: IUserSettings = {
  light_mode: 'light',
  language: 'en',
  currency: 'GBP',
  menu_collapsed: false,
};
